module.exports = __webpack_public_path__ + "static/media/profile-pic-2-circle.91f46ac9.png";